"use strict";
const angular = require("angular");

export class IncidentDetailController {
  /*@ngInject*/
  constructor(appConfig, $uibModalInstance, $state, incident, shared) {
    "ngInject";

    this.modal = $uibModalInstance;
    console.log("in constructor: ", incident);

    this.$state = $state;
    this.incident = incident;
    this.shared = shared;
  }

  editIncident() {
    this.modal.close();
    this.$state.go("incident", { id: this.incident.id });
  }
}

export default angular
  .module("hccApp.incidentDetail", [])
  .controller("IncidentDetailController", IncidentDetailController).name;



// WEBPACK FOOTER //
// ./client/app/dashboard/incidentDetail.controller.js